"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "What exactly is Direct Primary Care (DPC)?",
  answer: "Direct Primary Care is a healthcare model where you pay a flat monthly fee for unlimited access to your doctor. By removing the insurance middleman, we can offer longer appointments, transparent pricing, and a more personalized physician-patient relationship focused entirely on your health."
}, {
  question: "Do you still accept or bill my health insurance?",
  answer: "Crescent Direct Primary Care does not bill insurance for our services. Your monthly membership covers all office visits and many in-office procedures. We recommend maintaining a high-deductible or wrap-around plan for major medical events, hospitalizations, or specialist surgeries."
}, {
  question: "How do specialist referrals work in this model?",
  answer: "We handle your referrals with high-touch coordination. We work to find specialists who either accept your insurance or offer transparent cash pricing, ensuring your care journey remains seamless and affordable even when you need to step outside our primary care office."
}, {
  question: "Is my medical information kept private and HIPAA-compliant?",
  answer: "Absolutely. Protecting your health information is our legal and ethical priority. We utilize secure, HIPAA-compliant electronic health records and encrypted communication platforms to ensure your data remains confidential and protected at all times."
}, {
  question: "What if I need care after hours or while traveling?",
  answer: "Our members enjoy direct communication with their physician. Whether it is a phone call, text, or video chat, we are here to support you whenever urgent needs arise, providing peace of mind and continuity of care no matter where you are."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="139941" id="common-questions" className="relative w-full py-24 md:py-32 bg-background overflow-hidden">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-[0.02] select-none">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615506/img/dentalsync_logo_watermark.png" alt="" className="w-[800px] max-w-none object-contain" aria-hidden="true" />
      </div>

      <div ref={ref} className={`container mx-auto px-4 md:px-6 relative z-10 max-w-3xl transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-serif font-normal text-foreground tracking-tight mb-4">
            Common Questions
          </h2>
          <p className="text-lg font-sans text-muted-foreground max-w-2xl mx-auto">
            Transparent answers regarding our direct primary care model, insurance policies, and patient privacy.
          </p>
        </div>

        <div className="bg-card/70 backdrop-blur-md rounded-2xl p-6 md:p-8 border border-border/50 shadow-sm">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border/60 py-2">
                <AccordionTrigger className="text-[18px] font-sans font-bold text-foreground hover:text-primary transition-colors text-left hover:no-underline">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-lg font-serif text-muted-foreground leading-relaxed pt-2 pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}